
















import { Component, Vue, Prop } from "vue-property-decorator";
import MenuItem from "./MenuItem.vue";

export interface MenuSectionData {
  title: string;
  items: MenuItemData[];
}

export interface MenuItemData {
  icon: string;
  title: string;
  url: string;
  iconSize?: number;
}

@Component({ components: { MenuItem } })
export default class MenuSection extends Vue {
  @Prop({
    default: () => {
      return {
        title: "",
        items: [],
      };
    },
  })
  readonly value!: MenuSectionData;
}
